export const InventoryStatusEnum = {
  SERVICABLE: "SERVICABLE",
  DECOMMISSIONED: "DECOMMISSIONED"
}

export const InventoryStatusList = [
  "SERVICABLE",
  "DECOMMISSIONED",
]
